import { fmtRating } from "@/lib/api";

const NOT_ACQUIRED = "Ta place n'est pas acquise, et Google n'est plus le seul endroit où l'on cherche un architecte.";

function headline(u, query) {
  if (u.in_top3) return u.rank === 1 ? `Tu es à la 1re place. ${NOT_ACQUIRED}` : `Tu es ${u.rank}e. ${NOT_ACQUIRED}`;
  if (u.rank && u.rank <= 10) return `Tu es ${u.rank}e sur « ${query} »`;
  return "Tu n'apparais pas dans le top 10";
}

export default function PositionCard({ u, query, visibility, inApp = false }) {
  if (!u || u.status === "no_agency") return null;
  const box = "fade-up rounded-card border border-line bg-surface px-5 py-5";
  if (u.status === "not_found")
    return (
      <section data-testid="user-card" className={box}>
        <p className="text-xs font-medium uppercase tracking-[0.08em] text-muted">Ta position</p>
        <p className="mt-1.5 text-[15px] font-medium text-ink" data-testid="user-card-message">
          On ne te trouve pas sur cette recherche
        </p>
        <p className="mt-1 truncate text-[13px] text-muted">{u.agency}</p>
      </section>
    );
  return (
    <section data-testid="user-card" className={`${box} flex items-start justify-between gap-4`} aria-label="Ta position">
      <div className="min-w-0">
        <p className="text-xs font-medium uppercase tracking-[0.08em] text-muted" data-testid="position-title">
          Ta position
        </p>
        <p className={`mt-1.5 font-semibold tracking-[-0.01em] text-ink ${u.in_top3 ? "text-[17px] leading-snug" : "text-xl"}`} data-testid="user-rank-headline">
          {headline(u, query)}
        </p>
        <p className="mt-1.5 text-[13px] text-muted">
          {u.name || u.agency} · <span className="num text-ink">{u.reviews}</span> avis · note <span className="num text-ink">{fmtRating(u.rating)}</span>
        </p>
        <p className="mt-1 text-[12px] leading-snug text-muted" data-testid="user-rank-caveat">
          Classement indicatif, il varie selon l'endroit d'où l'on cherche.
        </p>
      </div>
      {(!inApp || visibility != null) && (
      <div className="shrink-0 text-right" data-testid="user-score">
        <p className="text-xs text-muted" data-testid="user-score-label">{inApp || visibility != null ? "Score de visibilité" : "Score Radar"}</p>
        <p className="mt-1 leading-none">
          <span className="num text-[34px] font-semibold text-ink" data-testid="user-score-value">
            {visibility != null ? visibility : u.score}
          </span>
          <span className="num text-[14px] text-muted">/100</span>
        </p>
      </div>
      )}
    </section>
  );
}
